import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgClass } from '@angular/common';

import { SdThemeComponent } from '../../abstract/theme/theme.component';
import { BrandThemesEnum, ThemesEnum } from '../../../_enums/themes.enum';
import { IconSizeEnum } from '../../../_enums/icon.enum';
import { PositionEnum } from '../../../_enums/position.enum';
import { SdLibConfig } from '../../../sd-lib-config';
import { AnimationsEnum } from '../../../_enums/animations.enum';
import { SdIconComponent } from '../../icons/icon/icon.component';
import { IMedia } from '../../../_interfaces/media.interface';

@Component({
  // tslint:disable-next-line
  selector: '[sd-button]',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdIconComponent, NgClass]
})
export class SdButtonComponent extends SdThemeComponent implements OnChanges {
  /**
   * The name of the icon
   */
  @Input()
  icon: string;

  /**
   * Manage the icon position (left or right) of the text
   */
  @Input()
  iconPos: PositionEnum.left | PositionEnum.right = PositionEnum.left;

  /**
   * Defined the size of the button (small or not)
   */
  @Input()
  isSmall = false;

  /**
   * Defined the global theme of the button (will impact colors)
   */
  @Input()
  theme: ThemesEnum | BrandThemesEnum.brand;

  /**
   * Allow the user to define if the button is only composed of an icon
   * It will allow the button to fit his icon (perfectly round, square, ...)
   */
  @Input()
  isIcon: boolean;

  /**
   * Defined if the button is plain or not (border only)
   */
  @Input()
  isSecondary: boolean;

  @Input()
  isPlayer = false;

  /**
   * Defined the size of the button (small or not)
   */
  @Input()
  isPagination = false;

  /**
   * The source of the image
   */
  @Input()
  image?: IMedia;

  /**
   * Manage the image position (left or right) of the text
   */
  @Input()
  imagePos?: PositionEnum.left | PositionEnum.right = PositionEnum.left;

  /**
   * Defined if the button is plain or not (border only)
   */
  @Input()
  isRoundedImage?: boolean;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.isIcon ? 'is-icon' : '',
      this.isSmall ? 'is-small' : '',
      this.isSecondary ? 'c--secondary' : '',
      this.theme && !this.isPlayer ? 'is-theme-' + this.theme : '',
      this.isPlayer ? 'is-player' : '',
      this.isPagination ? 'is-pagination' : '',
      this.animation ? 'is-animation-' + this.animation : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  positionEnum = PositionEnum;
  iconSize = IconSizeEnum;
  animation: AnimationsEnum;

  constructor(private sdLibConfig: SdLibConfig) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    this.setAnimation();
  }

  setAnimation(): void {
    this.animation = this.sdLibConfig.get(this.brand).animation;
  }
}
